import { createContext, useContext, useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { GRADIENTS } from "@/lib/constants";

const ThemeCtx = createContext({ theme: "light", toggle: () => {}, gradient: "electrique", setGradient: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("nmc-theme") || "light");
  const [gradient, setGradient] = useState(() => localStorage.getItem("nmc-gradient") || "electrique");
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("nmc-theme", theme);
  }, [theme]);
  useEffect(() => {
    const g = GRADIENTS.find((x) => x.id === gradient) || GRADIENTS[0];
    const lift = (hsl) => (theme === "dark" ? hsl.replace(/(\d+)%$/, (_, l) => `${Math.max(Number(l), 62)}%`) : hsl);
    const root = document.documentElement.style;
    root.setProperty("--primary", lift(g.from));
    root.setProperty("--ring", lift(g.from));
    root.setProperty("--violet", lift(g.to));
    localStorage.setItem("nmc-gradient", g.id);
  }, [gradient, theme]);
  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  return <ThemeCtx.Provider value={{ theme, toggle, gradient, setGradient }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);

export const ThemeToggle = ({ className = "" }) => {
  const { theme, toggle } = useTheme();
  return (
    <button
      data-testid="theme-toggle-button"
      onClick={toggle}
      aria-label="Changer de thème"
      className={`inline-flex h-9 w-9 items-center justify-center rounded-full border bg-card/60 text-muted-foreground transition-colors hover:text-foreground hover:border-primary/40 ${className}`}
    >
      {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
};
